var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "f_logo_RGB-Blue_1024") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.04 1024 0.04 1024 1017.78 0.06 1017.78"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f_logo_RGB-Blue_1024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024,512 C1024,229.23 794.77,0 512,0 C229.23,0 0,229.23 0,512 C0,767.554 187.231,979.37 432,1017.78 L432,660 L302,660 L302,512 L432,512 L432,399.2 C432,270.88 508.438,200 625.39,200 C681.407,200 740,210 740,210 L740,336 L675.438,336 C611.835,336 592,375.467 592,415.957 L592,512 L734,512 L711.3,660 L592,660 L592,1017.78 C836.769,979.37 1024,767.554 1024,512",
    id: "Fill-1",
    fill: "#1877F2",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M711.3,660 L734,512 L592,512 L592,415.957 C592,375.467 611.835,336 675.438,336 L740,336 L740,210 C740,210 681.407,200 625.39,200 C508.438,200 432,270.88 432,399.2 L432,512 L302,512 L302,660 L432,660 L432,1017.78 C458.067,1021.87 484.784,1024 512,1024 C539.216,1024 565.933,1021.87 592,1017.78 L592,660 L711.3,660",
    id: "Fill-4",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFIcon);
export default __webpack_public_path__ + "static/media/f-icon.bc60f4b2c0f6a7e44d737c5e12ed0734.svg";
export { ForwardRef as ReactComponent };